import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import FlashcardSetCard from "./FlashcardSetCard";
import { SimpleGrid } from "@mantine/core";
import { API_URL } from "../config";

export default function FlashcardSetGrid({ sets, setSets }) {
  const navigate = useNavigate();

  const onCardClick = (length, setId) => {
    if (length !== 0) {
      navigate(`/cards/${setId}`, { state: { setId } });
      console.log("card clicked!");
    } else {
      window.alert("There are no cards in the set!");
    }
  };

  const onEditClick = (setId) => {
    console.log("button clicked!");

    navigate(`/cards/${setId}/edit`);
  };

  function onDeleteClick(setId) {
    axios
      .delete(`${API_URL}/set/${setId}`)
      .then((res) => {
        console.log(res.data);
      })
      .catch((error) => {
        console.error(error);
      });

    setSets(sets.filter((set) => set._id !== setId));
  }

  return (
    <SimpleGrid style={{ marginTop: "3rem", marginLeft: "2.5rem" }} cols={4}>
      {sets.map(({ _id, title, flashcards }, index) => (
        <FlashcardSetCard
          key={index}
          setId={_id}
          title={title}
          length={flashcards.length}
          onCardClick={onCardClick}
          onEditClick={onEditClick}
          onDeleteClick={onDeleteClick}
        />
      ))}
    </SimpleGrid>
  );
}
